<template>
  <toast-notification v-show="errorBannerDisplay" :close-button-alt="$t('close')" @close="closeErrorBanner">
    <p>
      <span v-t>Something went wrong. Try again later or</span>
      &nbsp;
      <a v-t @click="showIntercom()">contact us</a>
    </p>
  </toast-notification>
</template>

<script>
import { toastNotification } from '@/components/layout';
import { intercom } from '@/lib/analytics';
import errorStore from '@/store/error';

const _ = {
  intercom,
  errorStore,
};

export default {
  _,
  components: {
    toastNotification,
  },
  data() {
    return {
      errorBannerDisplay: false,
    };
  },

  beforeCreate() {
    _.errorStore.addObserver('error_banner', ({ hasError }) => {
      this.errorBannerDisplay = hasError;
    });
  },
  beforeDestroy() {
    _.errorStore.removeObserver('error_banner');
  },

  methods: {
    showIntercom() {
      _.intercom('show');
    },

    closeErrorBanner() {
      _.errorStore.reset();
    },
  },
};
</script>
<style lang="scss" scoped>
  .error-message-container {
    display: flex;
    align-items: flex-start;
    margin: 1rem 1.5rem 0 0;

    .alert-triangle {
      height: 1rem;
      width: 1rem;
      margin: 0.2rem 0.75rem 0 0;
      fill: $neg-500;
      flex: 1 0 auto;
    }
  }
</style>
